import { Routes } from "@angular/router";

import { eventsListRoutes } from "../exhibitions-and-events";
import { schoolUniversityVisitsRoute } from "../requests-management";
import { learningCenterDashboardRoutes } from "./nested-features/dashboard";
import { disabilitiesRoutes, disabilitiesManagementRoutes } from "./nested-features/disability-types";
import { Permissions } from "src/assets/config/config";

export const learningCenterManagementRoutes: Routes = [
  {
    path: "",
    title: "LEARNING_CENTER.TITLE",
    data: {
      tabs: [
        {
          key: "Dashboard",
          title: "DASHBOARD.TITLE",
          routerLink: "dashboard",
        },
        {
          key: "ExhibitionsEvents",
          title: "EVENTS.TITLE",
          routerLink: "exhibitions-events",
        },
        {
          key: "SchoolUniversityRequests",
          title: "REQUESTS.SCHOOL_UNIVERSITY_REQUESTS",
          routerLink: "school-university-requests",
        },
        {
          key: "disabilityTypes",
          title: "DISABILITY_TYPES.TITLE",
          routerLink: "disability-types",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        children: learningCenterDashboardRoutes,
      },
      {
        path: "exhibitions-events",
        children: eventsListRoutes,
      },
      {
        path: "disability-types",
        data: { permissions: Permissions.DisabilityTypes },
        children: disabilitiesRoutes,
      },
      schoolUniversityVisitsRoute,
    ],
  },
  {
    path: "disability-types",
    data: { permissions: Permissions.DisabilityTypes },
    children: disabilitiesManagementRoutes,
  },
];
